import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceBoolean, coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';
import z from 'zod';

export enum McmPhotoType {
  INTERIOR_EXTERIOR = 'interior_exterior',
  EXTERIOR_ONLY = 'exterior_only',
  RESHOOT = 'reshoot',
  EDITORIAL = 'editorial',
  TWILIGHT = 'twilight',
  ECONOMY = 'economy',
}

export default createPerformableConfig(
  'photo',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      type: z.nativeEnum(McmPhotoType),
      twilight: coerceBoolean().optional(),
      extra_photos: z.coerce.number().min(0).optional(),
    }),
  },
  {
    name: 'Photography Services',
    short: '',
    package: 'Photography',
    tenant: TenantId.MOTION_CITY_MEDIA,
    thumbnail: '',
    images: [],
  },
);
